// extracted by mini-css-extract-plugin
export default {"VerifyTwoFAForm__twoFAInputFlex":"CY2esuMZOn","VerifyTwoFAForm__resendText":"WQlDSXoSRZ","VerifyTwoFAForm__timerText":"w3cqTulUUo","VerifyTwoFAForm__actionLink":"PIx2FAZUrS"};